import { getNames, registerLocale } from "i18n-iso-countries";
import pl from "i18n-iso-countries/langs/pl.json";

let countryNames: Record<string, string> | null = null;
export const getCountryNames = () => {
  if (!countryNames) {
    registerLocale(pl);
    countryNames = getNames("pl");
  }
  return countryNames;
};

export const getCountryName = (countryCode: string) =>
  getCountryNames()[countryCode] ?? countryCode;
